(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@js4Cytoscape/cxVizConverter"] = factory();
	else
		root["@js4Cytoscape/cxVizConverter"] = factory();
})(self, function() {
return 